import { Component, OnDestroy } from '@angular/core';
import { Subject, Subscription, Observable } from 'rxjs';
import { Router, UrlTree, UrlSegmentGroup } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormDropdownLabelService } from '@app/tw-shared/forms/form-dropdown/services';

@Component({
    selector: 'app-profile-me-leaderboard',
    templateUrl: './leaderboard.component.html',
    styleUrls: ['./leaderboard.component.scss'],
    providers: [
        {
            provide: FormDropdownLabelService,
            useFactory: () => new FormDropdownLabelService('dropdown-inside'),
        },
    ],
    standalone: false
})
export class ProfileMeLeaderboardComponent implements OnDestroy {
    /**
     * Close Subject
     */
    private closeSubject = new Subject<string>();

    /**
     * Subscriptions
     */
    private subscriptions = new Subscription();

    constructor(
        private router: Router,
        private translateService: TranslateService,
    ) {}

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Close Click
     */
    closeClick(): void {
        this.close('redirect');
    }

    /**
     * Cast Event on close with type
     * @param action close type
     */
    close(action: string): void {
        this.closeSubject.next(action);
    }

    /**
     * Close Popup
     * @return Observable close Subject
     */
    get closeEvent(): Observable<string> {
        return this.closeSubject.asObservable();
    }

    /**
     * Go Back Click
     */
    goBack(): void {
        this.router.navigateByUrl(this.goBackLink);
    }

    /**
     * Go Back Link
     */
    get goBackLink(): string {
        const tree: UrlTree = this.router.parseUrl(this.router.url);
        const g: UrlSegmentGroup = tree.root.children['primary'];
        const url = '/' + g.segments.map((segment) => segment.path).join('/');

        return url;
    }

    get leaderboardName() {
        return this.translateService.instant('v3-profile-slide-leaderboard-title');
    }
}
